import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Ref = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const ref = window.location.pathname.replace('/r/', '');
    localStorage.setItem('ref', ref);
    console.log(ref);
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
};

export default Ref;
